import { Box, Link, Typography } from '@mui/material';

import { COLORS } from '~/styles/colors';

type VCardPreviewListItemProps = {
  value: string;
  label: string;
  Icon: JSX.Element;
  linkHref?: string;
  isBorder?: boolean;
  rounded?: boolean;
  target?: string;
  rel?: string;
  isMarginHorizontal?: boolean;
  isAnonymous?: boolean;
};

export default function VCardPreviewListItem({
  value,
  label,
  Icon,
  linkHref,
  isBorder = false,
  rounded = true,
  target,
  rel,
  isMarginHorizontal = false,
  isAnonymous = false,
}: VCardPreviewListItemProps) {
  let margin: string | undefined;

  if (isMarginHorizontal) {
    margin = '0 2px';
  }

  if (isAnonymous) {
    margin = '0 5px';
  }

  return (
    <Box
      sx={{
        display: 'flex',
        padding: '8px 10px',
        alignItems: 'center',
        gap: '10px',
        borderBottom: isBorder ? '1px solid rgba(0, 0, 0, 0.12)' : undefined,
        borderRadius: rounded ? '12px' : undefined,
        backgroundColor: isAnonymous ? undefined : COLORS.white,
        margin,
      }}
    >
      <Box sx={{ padding: '4px', height: '24px', boxSizing: 'border-box' }}>{Icon}</Box>
      <Box>
        {linkHref ? (
          <Link
            href={linkHref}
            sx={{
              wordBreak: 'break-word',
              textDecoration: 'none',
              fontSize: '10px',
              color: COLORS.black08,
            }}
            target={target}
            rel={rel}
          >
            {value}
          </Link>
        ) : (
          <Typography sx={{ wordBreak: 'break-word', color: COLORS.black08, fontSize: '10px', textAlign: 'left' }}>
            {value}
          </Typography>
        )}

        {label && (
          <Typography sx={{ wordBreak: 'break-word', color: COLORS.black06, fontSize: '9px', textAlign: 'left' }}>
            {label}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
